module.exports = __webpack_public_path__ + "media/images/app/mail-setting-1baea0aed54414d8849fa4a0e97aeefc.svg";